import { render, staticRenderFns } from "./AssistTeacherDetail.vue?vue&type=template&id=20c7b5c0&scoped=true&"
import script from "./AssistTeacherDetail.vue?vue&type=script&lang=js&"
export * from "./AssistTeacherDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssistTeacherDetail.vue?vue&type=style&index=0&id=20c7b5c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c7b5c0",
  null
  
)

export default component.exports